import { useMemo } from 'react';
import { useGetSubscriptionPlanByIdQuery } from 'src/store/services';
import { useSession } from 'src/hooks';
import { getReferralId } from 'src/utils';
import { PriceDiscountType } from 'src/types/wallet/models/PriceDiscountType';

type UseSubscriptionPlanByIdProps = {
  plan_id?: string;
  seat_count?: number | null;
  shouldSkip?: boolean;
  stripe_promotion_code?: string;
  withoutReferral?: boolean;
  discountType?: PriceDiscountType;
};

export const useSubscriptionPlanById = ({
  plan_id,
  seat_count,
  stripe_promotion_code,
  shouldSkip,
  withoutReferral,
  discountType,
}: UseSubscriptionPlanByIdProps) => {
  const { appUser, isEnterpriseTier } = useSession();
  const referralId = getReferralId();

  const { data, isLoading, isFetching } = useGetSubscriptionPlanByIdQuery(
    {
      user_id: appUser.user_id,
      plan_id: plan_id || '',
      seat_count,
      stripe_promotion_code,
      referral_id: !!referralId && !withoutReferral ? referralId : undefined,
      discount_type: discountType,
    },
    {
      skip: isEnterpriseTier || shouldSkip || !plan_id,
      refetchOnMountOrArgChange: false, // todo check if it works correctly
    },
  );

  return useMemo(
    () => ({
      plan: data,
      isPlanLoading: isLoading || isFetching,
    }),
    [data, isLoading, isFetching],
  );
};
